// time-based chat option 
//  (function() {
//    var now = new Date();
//       var hours = now.getHours(); // Get current hour (0-23)
//       var day = now.getDay(); // Get current day (0 = Sunday, 6 = Saturday)

//       var isWeekend = (day === 0 || day === 6); // True if Saturday or Sunday
//       var isWorkHours = (hours >= 10 && hours < 17); // 10:00 AM - 5:00 PM on weekdays

//       if (!isWeekend && isWorkHours) {
//           // Load Zendesk Widget (Only on weekdays from 10:00 AM - 5:00 PM)
//           var zendeskScript = document.createElement("script");
//           zendeskScript.id = "ze-snippet";
//           zendeskScript.src = "https://static.zdassets.com/ekr/snippet.js?key=f7384f88-52c5-4e29-8d3b-7568fdbd3a3b";
//           document.head.appendChild(zendeskScript);
//       } else {
//           // Load UserLink Widget (Full day on weekends OR outside work hours on weekdays)
//           var userlinkScript = document.createElement("script");
//           userlinkScript.src = "https://files.userlink.ai/public/embed.min.js";
//           userlinkScript.charset = "utf-8";
//           userlinkScript.id = "bai-scr-emb";
//           userlinkScript.setAttribute("data-cid", "67d04ff16bdff26f4097865c");
//           userlinkScript.setAttribute("async", "");
//           userlinkScript.setAttribute("domain", "thenap.dk");
//           document.head.appendChild(userlinkScript);
//       }
// })();
(function() {
      // Get current time in Denmark (CET/CEST)
      var now = new Date();
      var denmarkTime = new Intl.DateTimeFormat("en-US", { 
          timeZone: "Europe/Copenhagen", 
          hour: "2-digit", 
          hour12: false, 
          weekday: "short" 
      }).formatToParts(now);

      // console.log(denmarkTime);

      var hours = parseInt(denmarkTime.find(part => part.type === "hour").value, 10); // Denmark's hour (0-23)
      var dayName = denmarkTime.find(part => part.type === "weekday").value; // Day name (e.g., "Mon", "Sat")

      var isWeekend = (dayName === "Sat" || dayName === "Sun"); // True if Saturday or Sunday
      var isWorkHours = (hours >= 9 && hours < 17); // 9:00 AM - 5:00 PM Denmark time (Weekdays only)

      if (!isWeekend && isWorkHours) {
          //Load Zendesk Widget (Only on weekdays from 9:00 AM - 5:00 PM in Denmark time)
          var zendeskScript = document.createElement("script");
          zendeskScript.id = "ze-snippet";
          zendeskScript.src = "https://cdn.herodesk.io/livechat.js?wid=de875a718c8531";
          document.head.appendChild(zendeskScript);
          console.log('herodesk');
      } else {
          //Load UserLink Widget (Full day on weekends OR outside work hours on weekdays in Denmark time)
          var userlinkScript = document.createElement("script");
          userlinkScript.src = "https://files.userlink.ai/public/embed.min.js";
          userlinkScript.charset = "utf-8";
          userlinkScript.id = "bai-scr-emb";
          userlinkScript.setAttribute("data-cid", "67d04ff16bdff26f4097865c");
          userlinkScript.setAttribute("async", "");
          userlinkScript.setAttribute("domain", "thenap.dk");
          document.head.appendChild(userlinkScript);
          console.log('userlinkScript');
      }
        // var zendeskScript = document.createElement("script");
        //   zendeskScript.id = "ze-snippet";
        //   zendeskScript.src = "https://static.zdassets.com/ekr/snippet.js?key=f7384f88-52c5-4e29-8d3b-7568fdbd3a3b";
        //   document.head.appendChild(zendeskScript);

        
          // var userlinkScript = document.createElement("script");
          // userlinkScript.src = "https://files.userlink.ai/public/embed.min.js";
          // userlinkScript.charset = "utf-8";
          // userlinkScript.id = "bai-scr-emb";
          // userlinkScript.setAttribute("data-cid", "67d04ff16bdff26f4097865c");
          // userlinkScript.setAttribute("async", "");
          // userlinkScript.setAttribute("domain", "thenap.dk");
          // document.head.appendChild(userlinkScript);
  })();


jQuery( document ).ready(function() {

  // Pre Order Text New option
  function getPreText(variantId) {
    return preTextData[String(variantId)] || null;
  }

  // Home page main slider 1 slide full click 
  jQuery('.slideshow-wrapper .swiper-slide[data-index="0"]').on('click',function(){
    var btn_link_slider = jQuery(this).find('.slideshow__buttons.rich-text__button a').attr('href');
    window.location = btn_link_slider;
  })
  
    // Product Page quantity Block  
    if(jQuery('#productquantity').length){


      jQuery('#productquantity').on("click",".qty-quick .select-menu .options li", function () {

          const $thisMenu = jQuery(this).closest(".select-menu");
          const selectedText = jQuery(this).html();
              $thisMenu.find('.options li').removeClass("active");
              $thisMenu.find(".sBtn-text").html(selectedText);
              $thisMenu.removeClass("active").removeClass("red-new-btn");
              jQuery(this).addClass('active');

              const main_wrapper = jQuery(this).closest('.select-menu-main');

              if(jQuery(this).closest('.quantity-input').hasClass('qty-option-bundle')){
                var product = JSON.parse(jQuery(this).closest('.quantity-input').attr('data-product-json'));
              }else{
                var product = JSON.parse(jQuery('#productquantity').attr('data-product-json'));
              }

              
              const selectedOptions = {};

              // Get selected size
              const selectedSize = jQuery(this).attr('data-option');

              // console.log(selectedSize);

              if (jQuery(this).closest('.select-menu').hasClass('other-option')) {
                  // Get allowed colors for selected size from variant list
                  const allowedColors = product.variants
                      .filter(v => v.option1 === selectedSize)
                      .map(v => v.option2);

                  // Loop through color options and show/hide based on allowedColors
                  const colorMenu = main_wrapper.find('.select-menu.color-option');

                  colorMenu.find('.options li').each(function () {
                      const $colorOption = jQuery(this);
                      const colorVal = $colorOption.attr('data-option');

                      if (allowedColors.includes(colorVal)) {
                          $colorOption.show();
                      } else {
                          $colorOption.hide();

                           // Check if the current active color is now invalid
                          const currentActiveColor = colorMenu.find('.options li.active').attr('data-option');

                          if (!allowedColors.includes(currentActiveColor)) {
                              // Remove current active
                              colorMenu.find('.options li').removeClass('active');

                              // Auto-select first allowed color
                              const firstAllowed = colorMenu.find('.options li').filter(function () {
                                  return allowedColors.includes(jQuery(this).attr('data-option'));
                              }).first();

                              if (firstAllowed.length) {
                                  firstAllowed.addClass('active');
                                  colorMenu.find('.sBtn-text').html(firstAllowed.html());
                                  selectedOptions['Vælg farve:'] = firstAllowed[0].attributes[0].nodeValue;
                              } 
                          }

                      }
                  });
              }
              
              
              const $thisMenu_new = jQuery(this).closest(".quantity-input");

              qty_option_get($thisMenu_new);
            
              // var main_sale_price = Shopify.formatMoney(matchedVariant.price, '{{amount_no_decimals}} kr');
              // main_wrapper.find('.f-price__sale .f-price-item--sale').text(main_sale_price);
              // main_wrapper.find('.f-price__regular .f-price-item--regular').text(main_sale_price);
            
              // if(matchedVariant.compare_at_price != null){
              //   var main_compare_price = Shopify.formatMoney(matchedVariant.compare_at_price, '{{amount_no_decimals}} kr');
              //   main_wrapper.find('.f-price__sale .f-price-item--regular s').text(main_compare_price);
              // }else{
              //   main_wrapper.find('.f-price__sale .f-price-item--regular s').text('');
              // }

              // if(matchedVariant.featured_image != null){
              //    main_wrapper.find('.product-card__image-wrapper img').attr('src',matchedVariant.featured_image.src);
              //    main_wrapper.find('.product-card__image-wrapper img').attr('srcset',matchedVariant.featured_image.src);
              // } 

        });


      function qty_option_get($get_curr){
         
        if($get_curr.hasClass('qty-option-bundle')){
          var product = JSON.parse($get_curr.attr('data-product-json'));
        }else{
          var product = JSON.parse(jQuery('#productquantity').attr('data-product-json'));
        }

        // console.log($get_curr.attr('data-product-json'));
        // console.log(product);
        // const product = JSON.parse(jQuery('#productquantity').attr('data-product-json'));
        $get_curr.attr('data-base-price', '0');
        const variantCount = {};
        const variantAvailable = {};


        $get_curr.find('.select-menu-main').each(function () {
          const selectedOptions = {};
          const selectedOptionsID = {};

          jQuery(this).find('.select-menu li.active').each(function () {
              const $option = jQuery(this);
              const optionName = $option.closest('.select-menu').attr('data-option-name');
              const optionValue = $option.attr('data-option');
              // const optionID = $option.attr('data-option-id');
              // console.log(optionID);
              selectedOptions[optionName] = optionValue;
              // selectedOptionsID[optionName] = optionID;
          });

          // Find matching variant
          const matchedVariant = product.variants.find(variant => {
              return variant.options.every((val, idx) => {
                  const optionName = product.options[idx];
                  return selectedOptions[optionName] === val;
              });
          });



          // console.log(selectedOptionsID);
          // sendVariantRequest(selectedOptionsID);
          console.log(matchedVariant);

          if (matchedVariant) {
            if (!matchedVariant.available) {
              jQuery(this).closest('.product-quick-option').find('.option-message').text('Udsolgt');
            } else{
              jQuery(this).closest('.product-quick-option').find('.option-message').text('');
            }

        //     if(matchedVariant.id == 55193729040709 && matchedVariant.available || matchedVariant.id == 54665342058821 && matchedVariant.available ||
        // matchedVariant.id == 55193739002181 && matchedVariant.available || matchedVariant.id == 55193741164869 && matchedVariant.available ||
        // matchedVariant.id == 55193742246213 && matchedVariant.available ){
        //       jQuery(this).closest('.product-quick-option').find('.option-message').text('Forudbestilling');
        //     }


        //     if(matchedVariant.id == 55325927244101 && matchedVariant.available || matchedVariant.id == 55533654704453 && matchedVariant.available ||
        // matchedVariant.id == 55533663519045 && matchedVariant.available || matchedVariant.id == 55533669384517 && matchedVariant.available ||
        // matchedVariant.id == 55533681312069 && matchedVariant.available){
        //       jQuery(this).closest('.product-quick-option').find('.option-message').text('Forudbestilling');
        //     }

        //     if(matchedVariant.id == 56481318273349 && matchedVariant.available){
        //       jQuery(this).closest('.product-quick-option').find('.option-message').text('Forudbestilling');
        //     }

        //     if(matchedVariant.id == 56509136798021 && matchedVariant.available || matchedVariant.id == 56509071851845 && matchedVariant.available ||
        // matchedVariant.id == 57992483602757 && matchedVariant.available || matchedVariant.id == 57992422850885 && matchedVariant.available ||
        // matchedVariant.id == 57992347451717 && matchedVariant.available){
        //       jQuery(this).closest('.product-quick-option').find('.option-message').text('Forudbestilling');
        //     }

        //     if(matchedVariant.id == 55193729007941 && matchedVariant.available || matchedVariant.id == 55328875315525 && matchedVariant.available ||
        // matchedVariant.id == 57992483537221 && matchedVariant.available || matchedVariant.id == 57992422785349 && matchedVariant.available ||
        // matchedVariant.id == 57992347386181 && matchedVariant.available){
        //       jQuery(this).closest('.product-quick-option').find('.option-message').text('Forudbestilling');
        //     }

          const pre_option_data = getPreText(matchedVariant.id);
          if(pre_option_data){
            jQuery(this).closest('.product-quick-option').find('.option-message').text(pre_option_data.option_message);
          }
			  } 

          // media change as per option color
          const mediaGallery = document.querySelector('media-gallery');
          if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
            mediaGallery.setActiveMedia(matchedVariant);
          }

          if (matchedVariant) {
              const variantId = matchedVariant.id;
              var get_main_pirce = $get_curr.attr('data-base-price');
              var new_pirce_main = parseInt(get_main_pirce) + parseInt(matchedVariant.price);
              $get_curr.attr('data-base-price', new_pirce_main);
              $get_curr.attr('data-compare-price', matchedVariant.compare_at_price);
              variantCount[variantId] = (variantCount[variantId] || 0) + 1;
              variantAvailable[variantId] = matchedVariant.available;
          }

          // console.log(matchedVariant);
          // console.log(variantCount);
          
      });

      var total_qty_select = $get_curr.find('input[name="quantitychange"]').val();
      var get_MainPirce = $get_curr.attr('data-base-price');
      var get_compare_at_price = $get_curr.attr('data-compare-price');
      var new_moneyFormat = '{{  amount_no_decimals_with_comma_separator }} kr';
      // console.log(get_MainPirce);
      // console.log(total_qty_select);

      if(total_qty_select == 2){
        var main_price_new = get_MainPirce / 100
        // if(product.id == 15263952666949 || product.id == 15231095963973){
        //   var discountAmount = (main_price_new * 15.7) / 100;
        // }else if(product.id == 15551721832773){
        //   var discountAmount = (main_price_new * 10.33) / 100;
        // }else if(product.id == 9238138749253){
        //   var discountAmount = (main_price_new * 15) / 100;
        // }else{
        //   var discountAmount = (main_price_new * 10) / 100;
        // }

        if(product.id == 15263952666949 || product.id == 15339195072837){
          // var discountAmount = (main_price_new * 25.29) / 100;
          var discountAmount = (main_price_new * 25.44) / 100;
        }else if(product.id == 15231095832901){
          var discountAmount = (main_price_new * 30) / 100;  
        }else if(product.id == 9238138749253 || product.id == 15050047160645 || product.id == 15050046669125 || product.id == 15050046374213 || product.id == 15047153090885){
          var discountAmount = (main_price_new * 5.42) / 100;
        }else if(product.id == 9587895468357){
          var discountAmount = (main_price_new * 6.20) / 100;
        }else if(product.id == 9527502766405){
          var discountAmount = (main_price_new * 20) / 100;
        }else if(product.id == 15231095963973){
          var discountAmount = (main_price_new * 24.96) / 100;
        }else{
          var discountAmount = (main_price_new * 10) / 100;
        }
        // var discountAmount = (main_price_new * 10) / 100;
        var finalPrice = main_price_new - discountAmount;

        // console.log(main_price_new);
        // console.log(finalPrice);
        // console.log(product.id);

        var discountedPrice = Math.floor(finalPrice * 100);
        $get_curr.find('.qty-bar-price').text(FoxTheme.Currency.formatMoney(discountedPrice, new_moneyFormat));
      }else{
        // console.log(product.id);

        if($get_curr.hasClass('qty-option-bundle') && product.id == 15723464556869){
          var main_price_new = get_MainPirce / 100;
          var discountAmount = (main_price_new * 15) / 100;
          var finalPrice = main_price_new - discountAmount;
          var discountedPrice = Math.floor(finalPrice * 100);
          $get_curr.find('.qty-bar-price').text(FoxTheme.Currency.formatMoney(discountedPrice, new_moneyFormat));
          // $get_curr.find('.qty-bar-price').text(product.id);
          // $get_curr.find('.qty-bar-full-price').text(FoxTheme.Currency.formatMoney(get_MainPirce, FoxTheme.settings.moneyFormat));
        }else{
          $get_curr.find('.qty-bar-price').text(FoxTheme.Currency.formatMoney(get_MainPirce, new_moneyFormat));
        }

        //  $get_curr.find('.qty-bar-price').text(FoxTheme.Currency.formatMoney(get_MainPirce, new_moneyFormat));
      }

      if($get_curr.hasClass('qty-option-2')){
        if(product.id == 9238138749253 || product.id == 15050047160645 || product.id == 15050046669125 || product.id == 15050046374213 || product.id == 15047153090885){
          $get_curr.find('.qty-bar-full-price').text(FoxTheme.Currency.formatMoney(get_MainPirce, new_moneyFormat));
        }
      }else{
        $get_curr.find('.qty-bar-full-price').text(FoxTheme.Currency.formatMoney(get_compare_at_price, new_moneyFormat));
      }
      
      // console.log(FoxTheme.Currency.formatMoney(get_MainPirce,new_moneyFormat));
      // console.log(FoxTheme.Currency.formatMoney(get_MainPirce,'{{  amount_with_comma_separator }} kr'));
      // console.log(FoxTheme.Currency.formatMoney(get_MainPirce,'{{  amount_no_decimals_with_comma_separator }} kr'));
      // console.log(FoxTheme.Currency.formatMoney(get_MainPirce,'{{  amount_no_decimals_with_space_separator }} kr'));
      // console.log(FoxTheme.settings.moneyFormat);
      // console.log(FoxTheme.settings);

      // console.log("🧾 Variant Quantities:", variantCount);
      var totalCount = Object.keys(variantCount).length;   

      
      var qty_input_check = jQuery('.main-product .main-product-form input[name="quantity"]'); 

      var final_product_id = ""; 
      var final_product_qty = ""; 

    
      if(totalCount == 1){
        jQuery('#productquantity').removeClass('has-two-option').removeAttr('data-option-two-id');
        $.each(variantCount, function(id, count) {
                
          final_product_id = id; 
          final_product_qty = count; 

        });

      }else{
        jQuery('#productquantity').addClass('has-two-option');
        
        var two_i = 0;
        $.each(variantCount, function(id, count) {    
          // console.log(two_i);      

          if(two_i == 0){
            final_product_id = id; 
            final_product_qty = count; 
          }

          if(two_i == 1){
            jQuery('#productquantity').attr('data-option-two-id',id);
          }

          two_i++;

        });
      }

      if(qty_input_check.length == 0){
         jQuery( ".main-product .main-product-form" ).prepend('<input type="hidden" name="quantity" value="'+final_product_qty+'">');
      }else{
          qty_input_check.attr('value',final_product_qty);
      }

      jQuery( ".main-product .main-product-form input[name='id']" ).attr('value',final_product_id);
      jQuery( ".main-product .product__block.product__block--price input[name='id']" ).attr('value',final_product_id);

      // console.log(variantAvailable[final_product_id]);
      // console.log(final_product_id);

      if (!variantAvailable[final_product_id]) {
        // console.log(final_product_id);      
        // disable Add to Cart or show "Sold Out"
        jQuery('.main-product .main-product-form .product-form__submit').attr('disabled','disabled');
        jQuery('.main-product .main-product-form .product-form__submit span.price-active').text('Udsolgt');
        jQuery('.main-product .product-inventory-new .product__inventory').addClass('product__inventory--out-of-stock').removeClass('product__inventory--in-stock');
        jQuery('.main-product .product-inventory-new .product__inventory-text').html('Kommer snart.<span class="black-text"> Skriv dig op til produktet nedenfor. </span>');

        if(final_product_id == 58148357374277 || final_product_id == 58016375931205){
          jQuery('.main-product .product-inventory-new .product__inventory-text').html('Udsolgt.');
          jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('UDSOLGT');
          // jQuery('.main-product .main-product-form .product-form__buttons')
        }

	  } else{

	  	jQuery('.main-product .main-product-form .product-form__submit').removeAttr('disabled');
	    jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('Tilføj til kurv');
	    jQuery('.main-product .product-inventory-new .product__inventory').addClass('product__inventory--in-stock').removeClass('product__inventory--out-of-stock');
	    jQuery('.main-product .product-inventory-new .product__inventory-text').html('På lager.<span class="black-text">1-4 hverdages levering </span>');
	  }

      // if(final_product_id == 55193729040709 && variantAvailable[final_product_id] || final_product_id == 54665342058821 && variantAvailable[final_product_id] ||
      //   final_product_id == 55193739002181 && variantAvailable[final_product_id] || final_product_id == 55193741164869 && variantAvailable[final_product_id] ||
      //   final_product_id == 55193742246213 && variantAvailable[final_product_id] ){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Forudbestilling.<span class="black-text">Forventes afsendt fra d. 15. maj.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('FORUDBESTIL HER');
      // }

      const pre_inventory_data = getPreText(final_product_id);
      if (pre_inventory_data) {
        jQuery('.main-product .product-inventory-new .product__inventory-text').html(`${pre_inventory_data.main_text}<span class="black-text">${pre_inventory_data.sub_text}</span>`);
        jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text(pre_inventory_data.button_text);
      }

      // if(final_product_id == 55325927244101 && variantAvailable[final_product_id] || final_product_id == 55533654704453 && variantAvailable[final_product_id] ||
      //   final_product_id == 55533663519045 && variantAvailable[final_product_id] || final_product_id == 55533669384517 && variantAvailable[final_product_id] ||
      //   final_product_id == 55533681312069 && variantAvailable[final_product_id] ){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Forudbestilling.<span class="black-text">Afsendes fra d. 8. juni.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('FORUDBESTIL HER');
      // }

      // if(final_product_id == 56509136798021 && variantAvailable[final_product_id] || final_product_id == 56509071851845 && variantAvailable[final_product_id] ||
      //   final_product_id == 57992483602757 && variantAvailable[final_product_id] || final_product_id == 57992422850885 && variantAvailable[final_product_id] ||
      //   final_product_id == 57992347451717 && variantAvailable[final_product_id]){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Forudbestilling.<span class="black-text">Afsendes fra d. 17. juni.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('FORUDBESTIL HER');
      // }

      // if(final_product_id == 55193729007941 && variantAvailable[final_product_id] || final_product_id == 57992347386181 && variantAvailable[final_product_id] ||
      //   final_product_id == 57992422785349 && variantAvailable[final_product_id] || final_product_id == 57992483537221 && variantAvailable[final_product_id] ||
      //   final_product_id == 55328875315525 && variantAvailable[final_product_id]){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Forudbestilling.<span class="black-text">Afsendes fra d. 17. juni.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('FORUDBESTIL HER');
      // }


      // if(final_product_id == 56481318273349 && variantAvailable[final_product_id]){
      //     jQuery('.main-product .product-inventory-new .product__inventory-text').html('Forudbestilling.<span class="black-text">Afsendes fra d. 15. juni.</span>');
      //     jQuery('.main-product .main-product-form .product-form__submit span[data-other-text]').text('FORUDBESTIL HER');
      // }
    }



      jQuery('.product-template .main-product .product-form__buttons .product-form__submit').on('click',function(){

        if(jQuery('#productquantity').hasClass('has-option') && jQuery('#productquantity').hasClass('has-two-option')){

           var product_data_id = jQuery('#productquantity').attr('data-option-two-id');
            
            setTimeout(function() {
                    
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: product_data_id
                  },
                  dataType: 'json',
                  success: function () {
                    console.log('Product Added');
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                      bubbles: true, detail: { open: false }
                    }));
                  },
                  error: function () {
                    
                  }
                });

            },1300);
        }
      })
      
      function qty_bundle_data(currn) {
         var product_quantity_check = jQuery(currn).find('input:checked').val();
          var product_id_check = jQuery(currn).find('input:checked').attr('data-product-id');
          var qty_input_check = jQuery('.main-product .main-product-form input[name="quantity"]');  
          // console.log(product_quantity_check);
          if(qty_input_check.length == 0){
             jQuery( ".main-product .main-product-form" ).prepend('<input type="hidden" name="quantity" value="'+product_quantity_check+'">');
          }else{
              qty_input_check.attr('value',product_quantity_check);
          }
          jQuery( ".main-product .main-product-form input[name='id']" ).attr('value',product_id_check);
      }
      
      jQuery(document).on('click','.quantity-main .quantity-input',function(e){
        var currn = jQuery(this);

        if(currn.closest('.quantity-main').hasClass('has-option')){
          qty_option_get(currn);
        }else{
          qty_bundle_data(currn);
        }

      });
      
      if(jQuery('.quantity-main').hasClass('has-option')){
          qty_option_get(jQuery('.quantity-input.active'));
        }else{
          qty_bundle_data(jQuery('.quantity-input.active'));
        }
      // qty_bundle_data(jQuery('.quantity-input.active'));

    }

  //   setInterval(function() {
  //     if(jQuery('.naptopper-bambus-lag-test').length == 1){
  //       var qty_select_div = jQuery('.naptopper-bambus-lag-test .quantity-main input[name="quantitychange"]:checked').closest('.quantity-input').find('.select-menu-main .select-menu:nth-child(1)');
  //       var qty_select_div_text = jQuery(qty_select_div).find('.sBtn-text').text().trim();
  //       if(qty_select_div_text == "160x200 cm" || qty_select_div_text == "180x200 cm"){
  //           jQuery(qty_select_div).addClass('custom-text-pre');
  //           jQuery('.product__inventory.main-default').removeClass('active');
  //           jQuery('.product__inventory.main-pre').attr('data-pre-ids','53793042923845,53645290799429').addClass('active');
  //           jQuery('.product__inventory.main-pre .product__inventory-text').html('Forudbestilling.<span class="black-text">Forventet afsendt fra uge 15.</span>');
  //           jQuery('.main-product .main-product-form .product-form__submit span').attr('style','--text-var: "FORUDBESTIL HER";').addClass('custom-btn-text');
  //       }else{
  //         // jQuery(qty_select_div).removeClass('custom-text-pre'); 
  //         jQuery('.main-product .main-product-form .product-form__submit span').attr('style','--text-var: "FORUDBESTIL HER";').addClass('custom-btn-text');
  //         jQuery('.product__inventory.main-default').addClass('active');
  //         jQuery('.product__inventory.main-pre').removeClass('active');
  //         jQuery('.main-product .main-product-form .product-form__submit span').removeClass('custom-btn-text');
  //       }
  //   }
  //     // console.log(qty_select_div_text);
  // },400);

  // setInterval(function() {
  //     if(jQuery('.naptopper-2').length == 1){
  //       var qty_select_div_text = jQuery('.product__block.product__block--variant_picker variant-selects select').val();
  //       if(qty_select_div_text == "160x200 cm" || qty_select_div_text == "160x200 cm" || qty_select_div_text == "160x200 cm"){
  //           jQuery('.product__inventory.main-pre .product__inventory-text').html('Forudbestilling.<span class="black-text">Forventet afsendt fra uge 20.</span>');
  //       }else{
  //         jQuery('.product__inventory.main-pre .product__inventory-text').html('Forudbestilling.<span class="black-text">Forventet afsendt fra uge 17.</span>');
  //       }
  //   }
  // },300);
  
  // setInterval(function() {
  //     if(jQuery('.naptopper-2').length == 1){
  //       var qty_select_div_text = jQuery('.product__block.product__block--variant_picker variant-selects select').val();
  //       if(qty_select_div_text == "160x200 cm"){
  //           jQuery('.product__inventory.main-pre .product__inventory-text').html('Forudbestilling.<span class="black-text">Afsendes fra d. 17. juni.</span>');
  //       }else{
  //         jQuery('.product__inventory.main-pre .product__inventory-text').html('Forudbestilling.<span class="black-text">Afsendes fra d. 15. juni.</span>');
  //       }
  //   }
  // },300);

    jQuery(document).on('click','.quantity-main .pro-option-qty li',function() {
        var pro_val_id = jQuery(this).attr('data-value-id');
        var pro_val_img = jQuery(this).attr('data-pro-img');
        var pro_sale_price = jQuery(this).attr('data-sale-price');
        var pro_price = jQuery(this).attr('data-price');
        var pro_val_text = jQuery(this).text();
        jQuery('.quantity-main .pro-option-qty li').removeClass('active');
        jQuery(this).addClass('active');
        jQuery(this).closest('.quantity-input').find('input').attr('data-product-id',pro_val_id);
        jQuery(this).closest('.quantity-input').find('.qty-bar-img img').attr('src',pro_val_img);
        jQuery(this).closest('.quantity-input').find('.qty-bar-price').text(pro_sale_price);
        jQuery(this).closest('.quantity-input').find('.qty-bar-full-price').text(pro_price);
        jQuery('.quantity-main .pro-option-qty .active-option p span').text(pro_val_text);
        if(jQuery(this).closest('.quantity-input').hasClass('active')){
            jQuery( ".main-product product-form.product-form form input[name='id']" ).attr('value',pro_val_id);
        }
    });
    

    function product_qty_btn() {
      var main_qty_price = jQuery('.quantity-main .quantity-input input:checked').next().find('.qty-bar-price').text();
      var main_qty_save_text = jQuery('.quantity-main .quantity-input input:checked').next().next().find('p').text();
  
      if(jQuery('.product-form__submit .price-info-btn').length == 1){
        jQuery('.product-form__submit .price-info-btn .pill_price').text(main_qty_price);
        if(main_qty_save_text != ""){
          jQuery('.product-form__submit .price-info-btn .saving-checkout').show().text(main_qty_save_text);
        }else{
          jQuery('.product-form__submit .price-info-btn .saving-checkout').hide().text(main_qty_save_text);
        }
      }
    }
    
    jQuery('.quantity-main .quantity-input input').on('click change',function() {
      product_qty_btn()
    })
    product_qty_btn();

  
    function variant_option_sticky_atc() {
      if(jQuery('.sticky-atc-bar .variant-option-product').length == 1){
        jQuery('.sticky-atc-bar__form').addClass('variant-bundles');
        var variant_option_html = jQuery('.sticky-atc-html').html();
        var main_sticky_id = jQuery('.sticky-atc-html .select-atc-bar .atc-bar-select-main').attr("data-product-id")
        jQuery('.sticky-atc-bar .variant-option-product').html(variant_option_html);
        var qty_input_id_check_onload = jQuery('.select .sticky-atc-bar__variant-select option');  
        
        if(qty_input_id_check_onload.length == 0){
             jQuery( ".select .sticky-atc-bar__variant-select" ).prepend('<option value="'+main_sticky_id+'" selected="true">Default Title</option>');
          }else{
              qty_input_id_check_onload.attr('value',main_sticky_id);
          }
    
        jQuery('.atc-bar-select-main').on('click', function() {
            jQuery(this).closest('.select-atc-bar').toggleClass('opened');
            jQuery(this).closest('.select-atc-bar').find('.atc-bar-content').fadeToggle('fast');
        });

        jQuery(document).on('click','.sticky-atc-bar .atc-bar-item',function(e){
          
          var get_html = jQuery(this).html();
          jQuery('.sticky-atc-bar .atc-bar-select-main').html(get_html);
          jQuery(this).closest('.select-atc-bar').toggleClass('opened');
          jQuery(this).closest('.select-atc-bar').find('.atc-bar-content').fadeToggle('fast');
          
          var product_quantity_check = jQuery(this).attr('data-val');
          var product_id_check = jQuery(this).attr('data-product-id');
          var qty_input_check = jQuery('.sticky-atc-bar  #product-form-sticky-atc-bar input[name="quantity"]');  
          var qty_input_id_check = jQuery('.select .sticky-atc-bar__variant-select option');  
            // console.log(product_quantity_check);
            if(qty_input_check.length == 0){
               jQuery( ".sticky-atc-bar  #product-form-sticky-atc-bar" ).prepend('<input type="hidden" name="quantity" value="'+product_quantity_check+'">');
            }else{
                qty_input_check.attr('value',product_quantity_check);
            }
            if(qty_input_id_check.length == 0){
             jQuery( ".select .sticky-atc-bar__variant-select" ).prepend('<option value="'+product_id_check+'" selected="true">Default Title</option>');
          }else{
              qty_input_id_check.attr('value',product_id_check);
          }
          // jQuery( ".sticky-atc-bar  #product-form-sticky-atc-bar input[name='id']" ).attr('value',product_id_check);
        });    
      }
    }
    
    variant_option_sticky_atc();
  

    
    jQuery(".faq-tabs li").click(function () {
      var tab_id = jQuery(this).attr("data-tab");
      
      jQuery(".faq-tabs li").removeClass("active");
      jQuery(".faq-tab-content").removeClass("active");

      jQuery(this).addClass("active");
      jQuery("#" + tab_id).addClass("active");
    });

    jQuery(".faq-question").click(function () {
      jQuery(this).next(".faq-answer").slideToggle();
      jQuery(this).toggleClass("open");
    });

  // Product Page After ATC scrolling text
    if(jQuery('.marquee-info').length){
      jQuery('.marquee-info').marquee({
          duration: 12000,
          gap: 10,
          delayBeforeStart: 0,
          direction: 'left',
          duplicateCount: 3,
          duplicated: true,
          startVisible: true    
      });
    };
  // Product Page After ATC scrolling text END

    // function pre_order_btn_text() {
    //   setTimeout(function(){
    //      var get_var_id = jQuery('.tyngdedyne-voksen .main-product .main-product-form input[name="id"]').val();
    //     console.log(get_var_id);
    //      if(get_var_id == '47403454562629'){
    //          jQuery('.tyngdedyne-voksen .main-product .main-product-form .product-form__submit').attr('style','--text-var:"Tilføj til kurv";');
    //      }else{
    //          jQuery('.tyngdedyne-voksen .main-product .main-product-form .product-form__submit').attr('style','--text-var:"FORUDBESTIL - D. 15 MARTS";');
    //      }
    //     },1800)
    // }

    // jQuery('body').on('click change','.tyngdedyne-voksen .main-product .product-form__input--button label',function() {
    //   pre_order_btn_text();
    // });
    // pre_order_btn_text();

  // Video Review ALL JS
    if( jQuery('.video_reviews .slider.videos').length ){ // video center mode reviews
        jQuery('.video_reviews .slider.videos').slick({
          mobileFirst: true,
          dots: false,
          infinite: false,
          loop: false,
          slidesToShow: 1,
          nextArrow: jQuery('.video_reviews .arrows .next'),
          prevArrow: jQuery('.video_reviews .arrows .prev'),
          responsive: [
            {
              breakpoint: 640,
              settings:{
                slidesToShow: 4,
                infinite: false,
                loop: false,
              }          
            }
          ]
        });
    
        jQuery('.video_reviews .slider.videos').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          var calc = ( (nextSlide) / (slick.slideCount-1) ) * 100;
          jQuery('.video_reviews .slider.videos button[data-state="pause"]').click();
      
          jQuery('.video_reviews .progress').css('background-size', calc + '% 100%').attr('aria-valuenow', calc );
          jQuery('.video_reviews .progress .slider__label').text( calc + '% completed' );
        });
      
      jQuery('.video_reviews .video button[data-state="play"]').click(function(){
        var $this = jQuery(this).parent('div');
        var video = $this.find('video').get(0);
    
        video.play();
        jQuery(this).fadeOut();
        $this.find('button[data-state="pause"]').fadeIn();
    
      });
      jQuery('.video_reviews .video button[data-state="pause"]').click(function(){
        var $this = jQuery(this).parent('div');
        var video = $this.find('video').get(0);
    
        video.pause();
        jQuery(this).fadeOut();
        $this.find('button[data-state="play"]').fadeIn();
    
      });
    
      jQuery('.video_reviews .video').mouseenter(function(){
        var $this = jQuery(this);
        var video = $this.find('video').get(0);
        if( !video.paused ){
          jQuery(this).find('button[data-state="pause"]').fadeIn();
        }
      });
    
      jQuery('.video_reviews .video').mouseleave(function(){
        var $this = jQuery(this);
        var video = $this.find('video').get(0);
        if( !video.paused ){
          jQuery(this).find('button').fadeOut();
        } else{
          jQuery(this).find('button[data-state="play"]').fadeIn();
        }
      });
  }
    // Video Review ALL JS END

    // Product Loop Section
    if(jQuery('.custom-product-in').length > 0){
      jQuery('.variant-option-dropdown').on('change', function () {
        var selectedVariantId = jQuery(this).val();
        var $parentContainer = jQuery(this).closest('.quick-shop-form');
        var $hiddenInput = $parentContainer.find('.quick-show-custom-id');
    
        if ($hiddenInput.length) {
          $hiddenInput.val(selectedVariantId);
          $hiddenInput.prop('disabled', false);
        }

        var selectedprice = jQuery(this).find(':selected').attr('data-price');
        var selectedcompareprice = jQuery(this).find(':selected').attr('data-compareprice');
        var selectedsave = jQuery(this).find(':selected').attr('data-save');
        var mainPrice = jQuery(this).closest('.custom-product-block').find('.product-price');
        mainPrice.find('.main-info-price').text(selectedprice);
        mainPrice.find('.main-info-compareprice').text(selectedcompareprice);
        jQuery(this).closest('.custom-product-block').find('.total-saving .save-total').text(selectedsave);
        
        var selectedImage = jQuery(this).find(':selected').data('image');
        var mainImage = jQuery(this).closest('.custom-product-block').find('.pro-img-cut img');
        if (selectedImage) {
          // console.log(selectedImage);
          mainImage.attr('src', selectedImage);
        }
        
      });
      // jQuery('.custom-product-block').each(function () {
      //     const defaultImage = jQuery(this).find('#variant-select option:selected').data('image');
      //     const mainImage = jQuery(this).find('.pro-img-cut img');
      //     if (defaultImage) {
      //       mainImage.attr('src', defaultImage);
      //     }
      //   });
    
    jQuery(document).on('click','.quick-shop-buttons .quick-shop-btn',function(e){
        e.preventDefault();
          jQuery(this).addClass('btn--loading');
            var product_data_id = jQuery(this).closest('.quick-shop-buttons').find('.quick-show-custom-id').val();
            // console.log(product_data_id);
            // setTimeout(function() {
                    
                $.ajax({
                  type: 'POST',
                  url: '/cart/add.js',
                  data: {
                    quantity: 1,
                    id: product_data_id
                  },
                  dataType: 'json',
                  success: function () {
                    console.log('Quick Loop Product Added');
                    jQuery('.quick-shop-buttons .quick-shop-btn').removeClass('btn--loading');
                    document.dispatchEvent(new CustomEvent('cart:refresh', {
                      bubbles: true, detail: { open: true }
                    }));
                  },
                  error: function () {
                    
                  }
                });

            // },1300);
        
      })
    }
   // Product Loop Section end

  if(jQuery('.sticky-atc-bar').length > 0){
    var windowsize = jQuery(window).width();
  // if (windowsize < 749) {
      jQuery('.sticky-atc-bar').removeClass('sticky-atc-bar--show');
      jQuery(window).on('scroll', function() {
        var scroll = jQuery(window).scrollTop(); 
        var add_to_btn_max = jQuery('body .main-product-form').offset().top - jQuery(window).height() + 100;
        var add_to_btn_min = jQuery('body .main-product-form').offset().top;
        if(jQuery('.sticky-atc-bar .atc-bar-select-main').length){
          var bodyatc_class = 'sticky-atc-active2';
          jQuery('.select-atc-bar').removeClass('opened');
          jQuery('.sticky-atc-bar .atc-bar-content').hide();
        }else{
          var bodyatc_class = 'sticky-atc-active';
        }
        // scroll > add_to_btn_max &&
          if (scroll < add_to_btn_min) {
              jQuery('.sticky-atc-bar').removeClass('sticky-atc-bar--show');
              $('body').removeClass(bodyatc_class);
          }else{
            jQuery('.sticky-atc-bar').addClass('sticky-atc-bar--show');
            $('body').addClass(bodyatc_class);
          }
      });
  };


  if(jQuery('.mySwiper.clientslide').length > 0){
      var swiper = new Swiper(".mySwiper.clientslide", {
         loop: true,
          freeMode: true,
          spaceBetween: 10,
          grabCursor: true,
          slidesPerView: 5,
          loop: true,
          direction: "horizontal",
          autoplay: true,
          autoplay: {
            delay: 1,
            disableOnInteraction: false
          },
         breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 5,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
            1920: {
            slidesPerView: 5,
            spaceBetween: 10,
          },
        },
        freeMode: true,
        speed: 4000,
        freeModeMomentum: false
      });
    };

    if(jQuery('.client-review-slider').length > 0){
      new Swiper(".client-review-slider", {
            loop: true,
            allowTouchMove: true,
            grabCursor: true,
            speed: 5000,
            slidesPerView: "auto",
            spaceBetween: 12,

            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false
            },

            freeMode: true,
            freeModeMomentum: false,

            breakpoints: {
                768: {
                  slidesPerView: "auto"
                }
            }
        });
    };

    if(jQuery('.testimonial-slider').length > 0){
      var testimonialSwiper = new Swiper('.testimonial-slider', {
        loop: true,
        spaceBetween: 20,
        slidesPerView: 1,
        pagination: {
          el: '.cooling-testimonials .swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.cooling-testimonials .swiper-button-next',
          prevEl: '.cooling-testimonials .swiper-button-prev',
        },
        breakpoints: {
            768: {
              slidesPerView: 2
            }
          }
      });
    };

    jQuery('.custom-product-block .product-info .pro-bottom-col.full-link').on('click',function(){
        var get_full_link = jQuery(this).attr('data-href');
        window.location = get_full_link;
    })
  
    // function onload_price_add(curr) {
    //   var main_price = jQuery(curr).find('.kaching-bundles__bar-price').text();

    //   let price_number = parseInt(main_price.replace(/[^\d]/g, ""));

    //   if(price_number == 1071){
    //    var new_price = '1,070 kr';
    //   }else{
    //     var new_price = main_price;
    //   }
    //    jQuery('.napcool-uk-tekst span.price-info-btn .pill_price').attr('data-price',new_price);
    // }
    
    // jQuery('.napcool-uk-tekst .kaching-bundles .kaching-bundles__bars .kaching-bundles__bar').on('click',function() {
    //     onload_price_add(jQuery(this));
    // })
  
    // onload_price_add(jQuery('.napcool-uk-tekst .kaching-bundles .kaching-bundles__bars .kaching-bundles__bar.kaching-bundles__bar--selected'));

  setInterval(function() {
      var main_price =  jQuery('.napcool-uk-tekst .kaching-bundles .kaching-bundles__bars .kaching-bundles__bar.kaching-bundles__bar--selected .kaching-bundles__bar-price').text();
      let price_number = parseInt(main_price.replace(/[^\d]/g, ""));

      if(price_number == 1071){
       var new_price = '1,070 kr';
      }else{
        var new_price = main_price;
      }
       jQuery('.napcool-uk-tekst span.price-info-btn .pill_price').attr('data-price',new_price);
        if(jQuery('.napcool-uk-tekst .kaching-bundles__bars .kaching-bundles__bar:nth-child(2)').hasClass('kaching-bundles__bar--selected')){
         jQuery('.napcool-uk-tekst .kaching-bundles__bars .kaching-bundles__bar:nth-child(2) .kaching-bundles__bar-pricing .kaching-bundles__bar-price').attr('data-price',new_price);
        }
  },400);

  
});





jQuery(document).ready(function() {
	jQuery('body').on("click",".product-quick-option .select-btn",function (e) {
    // console.log('demo');
		e.stopPropagation();

		const $thisMenu = jQuery(this).closest(".select-menu");
		jQuery(".select-menu").not($thisMenu).removeClass("active");
		$thisMenu.toggleClass("active");
	});

	// Click handler for option items
	jQuery('body').on("click",".product-card__wrapper:not('.qty-quick') .select-menu .options li", function () {

		const $thisMenu = jQuery(this).closest(".select-menu");
		const selectedText = jQuery(this).html();
        $thisMenu.find('.options li').removeClass("active");
		$thisMenu.find(".sBtn-text").html(selectedText);
		$thisMenu.removeClass("active").removeClass("red-new-btn");
        jQuery(this).addClass('active');

        const main_wrapper = jQuery(this).closest('.custom-product-wrapper');
        const product = JSON.parse(main_wrapper.attr('data-product-json'));
        const selectedOptions = {};
        var curr = jQuery(this);
        jQuery(curr).addClass('loading');
    
        main_wrapper.find('.select-menu li').each(function () {
          if(jQuery(this).hasClass('active')){
            const optionName = jQuery(this).closest('.select-menu').attr('data-option-name');
            const optionValue = jQuery(this).attr('data-option');
            selectedOptions[optionName] = optionValue;
          }
        });
        
        let matchedVariant = null;
        if (product.variants.length === 1 && product.options.length === 1 && product.options[0] === "Title") {
          // Type 1: No options
          matchedVariant = product.variants[0];
        } else {
          // Match variant with selected options
          matchedVariant = product.variants.find(variant => {
            return variant.options.every((val, idx) => {
              const optionName = product.options[idx];
              return selectedOptions[optionName] === val;
            });
          });
        }

        console.log(matchedVariant);
      
        var main_sale_price = Shopify.formatMoney(matchedVariant.price, '{{amount_no_decimals}} kr');

        if(main_wrapper.find('.f-price.free-price-main').length == 0){
          
          main_wrapper.find('.f-price__sale .f-price-item--sale').text(main_sale_price);
          main_wrapper.find('.f-price__regular .f-price-item--regular').text(main_sale_price);
        
          if(matchedVariant.compare_at_price != null){
            var main_compare_price = Shopify.formatMoney(matchedVariant.compare_at_price, '{{amount_no_decimals}} kr');
            main_wrapper.find('.f-price__sale .f-price-item--regular s').text(main_compare_price);
          }else{
            main_wrapper.find('.f-price__sale .f-price-item--regular s').text('');
          }
          
        }else{
          main_wrapper.find('.f-price__sale .f-price-item--regular s').text(main_sale_price);
        }

        if(matchedVariant.featured_image != null){
           main_wrapper.find('.product-card__image-wrapper img').attr('src',matchedVariant.featured_image.src);
           main_wrapper.find('.product-card__image-wrapper img').attr('srcset',matchedVariant.featured_image.src);
        } 

	});

	// Click outside to close all dropdowns
	jQuery(document).on('click','.product-quick-option', function (e) {
		if (!jQuery(e.target).closest('.select-menu, .options').length) {
			jQuery('.select-menu').removeClass('active');
		}
	});



// Custom upsell Add to cart
  jQuery('body').on('click','#custom-add-to-cart', function () {
    const $wrapper = jQuery(this).closest('.custom-product-wrapper');
    const product = JSON.parse($wrapper.attr('data-product-json'));
    const selectedOptions = {};

    const get_free = jQuery(this).attr('data-price-free');

    var curr = jQuery(this);
    jQuery(curr).addClass('loading');

    $wrapper.find('.select-menu li').each(function () {
      if(jQuery(this).hasClass('active')){
        const optionName = jQuery(this).closest('.select-menu').attr('data-option-name');
        const optionValue = jQuery(this).attr('data-option');
        selectedOptions[optionName] = optionValue;
      }
    });
    
    let matchedVariant = null;
    if (product.variants.length === 1 && product.options.length === 1 && product.options[0] === "Title") {
      // Type 1: No options
      matchedVariant = product.variants[0];
    } else {
      // Match variant with selected options
      matchedVariant = product.variants.find(variant => {
        return variant.options.every((val, idx) => {
          const optionName = product.options[idx];
          return selectedOptions[optionName] === val;
        });
      });
    }


    if (matchedVariant) {

      if(get_free){
        var dynamicData = {
          quantity: 1,
          id: matchedVariant.id,
          properties: {
            '_free_gift': 'true'
          }
        };
      }else{
        var dynamicData = {
          quantity: 1,
          id: matchedVariant.id
        };
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: dynamicData,
        dataType: 'json',
        success: function () {
          jQuery(curr).removeClass('loading');
          // $wrapper.find('.message').text('Added to cart!');
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true, detail: { open: true }
          }));
          jQuery('body').addClass('cart-show');
        },
        error: function () {
          jQuery(curr).removeClass('loading');
          $wrapper.find('.select-menu').addClass('red-new-btn');
          // $wrapper.find('.message').text('Error adding to cart.');
        }
      });
    } else {
      jQuery(curr).removeClass('loading');
      $wrapper.find('.select-menu').addClass('red-new-btn');
      // $wrapper.find('.message').text('Please select all required options.');
    }
  });

  function free_cart_gift() {
    const swiperEl = document.querySelector('.cart-drawer-gifts .swiper');
    if (swiperEl) {
      const slides = swiperEl.querySelectorAll('.swiper-slide');
        if (slides.length >= 2) {
          new Swiper(swiperEl, {
            slidesPerView: 1.2,
            spaceBetween: 20,
          });
        }
    }
  }
  
  free_cart_gift();
  
  document.addEventListener('cart:updated', function(evt) {
    free_cart_gift()
  });

  setInterval(function() {
      if(jQuery('#CartDrawer').length && $('#CartDrawer')[0].hasAttribute('open') && $('#CartDrawer')[0].hasAttribute('active')){
          jQuery('body').addClass('cart-show');
      }else{
          jQuery('body').removeClass('cart-show');
      }
  },400);



  if(jQuery('.product_variations_static').length > 0){
    $(document).on('click','.product_variations_static .stc-swatches a',function(e){
      e.preventDefault();
      var product_main = $(this).closest('product-info.main-product');
      var fetchVariantURL = $(this).attr('href');
      fetch(fetchVariantURL).then((response) => {
          return response.text();
        }).then((html) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          window.history.pushState({}, "", fetchVariantURL);                   
          // $('.css-slider-viewport').parent().html($(html).find('.css-slider-viewport'));
          // $('.product-gallery__thumbnails-holder').parent().html($(html).find('.product-gallery__thumbnails-holder'));
          $($(html).find('.main-product')).insertBefore('product-info.main-product');
          $(product_main).remove();
          // $('product-page.main-product').html($(doc).find('product-page.main-product').html());
          setTimeout(function(){
            $("html, body").animate({ scrollTop: 0 }, "fast");
            $(product_main).remove();
          },400);
        });
      })

        // // Reload function
        // function reloadSection(sectionId, productId) {
        //   $.get('/?section_id=' + sectionId + '&product_id=' + productId + '&limit=1', function(data) {
        //     var $html = $(data);
        //     var $newSection = $html.find('#MainProduct-' + sectionId);

        //     $('#MainProduct-' + sectionId).replaceWith($newSection);
        //   });
        // }

        // // Click event
        // $(document).on('click', '.product_variations_static .stc-swatches a', function(e) {
        //   e.preventDefault();

        //   // Get product ID correctly
        //   var productId = $(this).attr('data-pro-id');   // OR $(this).data('proId');
        //   var sectionId = $('product-info.main-product').attr('data-section');

        //   console.log("Clicked product id:", productId, "Section ID:", sectionId);

        //   if (productId && sectionId) {
        //     reloadSection(sectionId, productId);
        //   }
        // });





    };
  
});



// Example: Testing promotional banners
// async function initBodyClass() {
//   // Replace with your actual hypothesis ID from Shoplift dashboard
//     const variantId = "019d90e3-8c9b-79d0-9a1d-b43708c35a0d";
    
//     try {
//       // Check if visitor is in the variant group
//       const showMainTest = await window.shoplift.isHypothesisActive(variantId);
      
//       if (showMainTest) {
//         document.body.classList.toggle('hide-before-price');

//         if ($('.quantity-main').length) {

//           function updateDoublePrice() {

//             let priceText = $('.quantity-input.qty-option-1 .qty-bar-price').text().trim();
//             if (!priceText) return;

//             let price = parseFloat(priceText.replace(/[^\d.]/g, ''));

//             if (isNaN(price)) return;

//             // Multiply by 2
//             let newPrice = price * 2;
//             let currency = priceText.replace(/[\d\s.,]/g, '');

//             // Set new price
//             $('.quantity-input.qty-option-2 .qty-bar-full-price').text(newPrice + ' ' + currency);
//           }


//           // Run on page load
//           updateDoublePrice();
//           setTimeout(() => {
//             updateDoublePrice();
//           }, 600);
          
//         }
//       } 
//     } catch (error) {
//       // Always fail gracefully - show control experience on error
//       console.error('Shoplift test failed:', error);
//   }
// }

// // Run when page loads
// document.addEventListener('DOMContentLoaded', initBodyClass);


// Example: Testing promotional banners
async function initNapCoolImage() {
  // Replace with your actual hypothesis ID from Shoplift dashboard
    const variantId = "019ea591-f31e-7cf0-a00c-02c51f0cd6c4";
    
    try {
      // Check if visitor is in the variant group
      const showMainTest = await window.shoplift.isHypothesisActive(variantId);
      
      if (showMainTest) {
        // document.body.classList.toggle('hide-before-price');

        if ($('.main-product[data-product-id="9238138749253"] .product__media-gallery .product__media-item[data-media-index="0"] .product__media-container').length) {

          var video_html = `
          <img src="https://cdn.shopify.com/s/files/1/0560/8770/7708/files/1780056018465-7bpkkfujx3k.png?v=1780057466" alt="" width="1946" height="1946" loading="lazy" is="image-lazy" fetchpriority="low" sizes="(max-width: 768px) calc(100vw - 3rem), calc(((min(1440px, 100vw) * 0.5) - 4.5rem) / 1)" >
        </motion-element><span class="product__media-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-zoom icon--medium" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
  <path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z"></path><path d="M16.4434 16.4453L20.9997 21.0016"></path>
</svg>
</span>
          <button class="product__media-zoom btn--inherit js-photoswipe--zoom" type="button" aria-haspopup="dialog" data-media-id="72248910250309" data-media-type="image" data-media-index="2">
            <span class="visually-hidden">
              Åbn medie 4 i modal
            </span>
          </button>`;

      var video_thub_html = `
       <div class="product__thumbs-inner" style="--aspect-ratio: 1" bis_skin_checked="1">
          <img src="https://cdn.shopify.com/s/files/1/0560/8770/7708/files/1780056018465-7bpkkfujx3k.png?v=1780057466" alt="CloudOne™ Den bløde hovedpude" is="image-lazy">
        </div>`;

      $('.main-product[data-product-id="9238138749253"] .product__media-gallery .product__media-item[data-media-index="0"] .product__media-container').html(video_html);
      $('.main-product[data-product-id="9238138749253"] .product__media-gallery .product__thumbs-item[data-media-id="63635721584965"] .product__thumbs-container').html(video_thub_html);
          
        }
        if ($('.main-product[data-product-id="9238138749253"] .product__media-gallery .product__media-item[data-media-index="2"] .product__media-container').length) {

          var video_html = `
          <img src="https://cdn.shopify.com/s/files/1/0560/8770/7708/files/Produktbilleder_2026_84.jpg?v=1780057465" alt="" width="1946" height="1946" loading="lazy" is="image-lazy" fetchpriority="low" sizes="(max-width: 768px) calc(100vw - 3rem), calc(((min(1440px, 100vw) * 0.5) - 4.5rem) / 1)" >
          </motion-element><span class="product__media-icon" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-zoom icon--medium" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
    <path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z"></path><path d="M16.4434 16.4453L20.9997 21.0016"></path>
  </svg>
  </span>
            <button class="product__media-zoom btn--inherit js-photoswipe--zoom" type="button" aria-haspopup="dialog" data-media-id="72248910250309" data-media-type="image" data-media-index="2">
              <span class="visually-hidden">
                Åbn medie 4 i modal
              </span>
            </button>`;

        var video_thub_html = `
        <div class="product__thumbs-inner" style="--aspect-ratio: 1" bis_skin_checked="1">
            <img src="https://cdn.shopify.com/s/files/1/0560/8770/7708/files/Produktbilleder_2026_84.jpg?v=1780057465" alt="CloudOne™ Den bløde hovedpude" is="image-lazy">
          </div>`;

        $('.main-product[data-product-id="9238138749253"] .product__media-gallery .product__media-item[data-media-index="2"] .product__media-container').html(video_html);
        $('.main-product[data-product-id="9238138749253"] .product__media-gallery .product__thumbs-item[data-media-position="3"] .product__thumbs-container').html(video_thub_html);
            
          }
      } 
    } catch (error) {
      // Always fail gracefully - show control experience on error
      console.error('Shoplift test failed:', error);
  }
}
// // Run when page loads
document.addEventListener('DOMContentLoaded', initNapCoolImage);



// COPY CODE
jQuery(document).ready(function($){

  $(document).on("click",".copy-code",function(){

      var code = $(this).data("code");
      var el = $(this);

      function fallbackCopy(text){
          var temp = $("<input>");
          $("body").append(temp);
          temp.val(text).select();
          document.execCommand("copy");
          temp.remove();
      }

      if(navigator.clipboard && navigator.clipboard.writeText){
          navigator.clipboard.writeText(code).catch(function(){
              fallbackCopy(code);
          });
      }else{
          fallbackCopy(code);
      }

      el.addClass("copied show-tooltip");

      setTimeout(function(){
          el.removeClass("copied show-tooltip");
      },2000);

  });


    // TIMER FUNCTION
    function updateTimers(){

        $(".promo-banner").each(function(){

            var banner = $(this);
            var endDate = banner.data("end");
            var end = new Date(endDate).getTime();
            var now = new Date().getTime();
            var distance = end - now;

            if(distance <= 0){
                banner.hide();
                return;
            }

            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            if(days > 0){
              banner.find(".timer").text(
                  days + "d : " + hours + "t : " + minutes + "m : " + seconds + "s"
              );
            } else{
              banner.find(".timer").text(
                hours + "t : " + minutes + "m : " + seconds + "s"
            );
            }

        });

    }

    setInterval(updateTimers,1000);
    updateTimers();

});




// // Example: Testing promotional banners
// async function initnapcoolWhite() {
//     setTimeout(function() {
//       const qtyOption2Elements = document.querySelectorAll(
//           '.napcool-2026 .quantity-input.qty-option-2 .color-option .options li[data-option-id="9840459514181"]'
//       );

//       qtyOption2Elements.forEach(element => {
//           if (element && element.matches('li[data-option-id="9840459514181"]')) {
//               element.click();
              
//           } 
//       });
//   }, 100); 

//       setTimeout(function() {
//           const element = document.querySelector(
//               '.napcool-2026 .quantity-input.qty-option-1.active .color-option .options li[data-option-id="9840459514181"]'
//           );

//           if (element) {
//               element.click();
//           } 
//       }, 200); 
// }

// // Run when page loads
// document.addEventListener('DOMContentLoaded', initnapcoolWhite);




// $(window).on('scroll load', function () {
//   var spinOffer = $('.spin-offer');

//   if (spinOffer.length) {
//     var scrollTop = $(window).scrollTop();
//     var triggerPoint = spinOffer.offset().top + spinOffer.outerHeight();

//     if (scrollTop > triggerPoint) {
//       $('.custom-fixed-bar').addClass('show');
//     } else {
//       $('.custom-fixed-bar').removeClass('show');
//     }
//   }
// });
jQuery(document).ready(function () {
  setTimeout(function() {
          const element = document.querySelector(
              '.nappod .quantity-input.qty-option-2 input#quantity_two'
          );

          if (element) {
              element.click();
          } 
      }, 800); 
})
jQuery(document).ready(function () {
   jQuery('button#customClose').on('click', function (e) {
    jQuery('.custom-fixed-bar').addClass('hidden');
   }); 

    jQuery('.section-bg-buttons .button-wrapper .button,.nap-btn,.image-with-text a').on('click', function (e) {
        var targetHref = jQuery(this).attr('href');

        // Check if href is an internal section link like #section-one
        if (targetHref && targetHref.startsWith('#')) {
            e.preventDefault();

            var $targetSection = jQuery(targetHref);

            // If target section exists
            if ($targetSection.length) {
                // Get header height (for fixed header)
                var headerHeight = jQuery('header.header').outerHeight() || 0;

                // Calculate scroll position with header offset
                var targetPosition = $targetSection.offset().top - headerHeight - 20;

                // Smooth scroll
                jQuery('html, body').animate({
                    scrollTop: targetPosition
                }, 350);
            }
        }
        // else normal URL will work automatically
    });
});